import useBreakpoint from 'hooks/useBreakpoint';

const getDirection = (direction, reverse) => {
  let formattedDirection = 'row';

  const breakpoint = useBreakpoint().breakpoint;
  const isMobile = ['xs'].includes(breakpoint);

  if (direction === 'Vertical' || (!direction && isMobile)) {
    formattedDirection = 'column';
  }

  return reverse ? `${formattedDirection}-reverse` : formattedDirection;
};

export default getDirection;
